import React, { useState, useRef, useLayoutEffect } from 'react'
import PropTypes from 'prop-types'
import { useInnerBlocks } from 'gutenberg/utils'
import Draggable from 'react-draggable'
import {
  MouseParallaxContainer,
  MouseParallaxChild,
} from 'react-parallax-mouse'

import {
  Wrapper,
  CircleWrap,
  InnerWrap,
  InnerBlocksContent,
  Content,
  Image,
  Decor,
  BGImage,
  Breadcrumbs,
} from './custom.styled'
import { Container } from '../../styled-components/Layout'

const SubPageHeader = ({
  isEditor = false,
  breadcrumbs,
  children,
  align,
  image,
  decor_image,
  decor_position,
  setAttributes,
}) => {
  const { InnerBlocks, ref } = useInnerBlocks(children, InnerBlocksContent)
  const refWrapper = useRef(null)
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  useLayoutEffect(() => {
    setWidth(refWrapper.current.clientWidth)
    setHeight(refWrapper.current.clientHeight)
  }, [])

  return (
    <Wrapper data-align={align}>
      <CircleWrap>
        <InnerWrap ref={refWrapper}>
          <Image isEditor={isEditor}>
            {isEditor ? (
              <>
                {image.url && (
                  <BGImage src={image.url} alt={image.alt || image.title} />
                )}
                {decor_image.url && (
                  <Draggable
                    onStop={(e, data) => {
                      setAttributes({
                        decor_position: {
                          transform: data.node.style.transform,
                          x: data.x,
                          y: data.y,
                        },
                      })
                    }}
                    position={decor_position}
                  >
                    <Decor
                      src={decor_image.url}
                      alt={decor_image.alt || decor_image.title}
                      isEditor={isEditor}
                    />
                  </Draggable>
                )}
              </>
            ) : (
              <MouseParallaxContainer useWindowMouseEvents={true}>
                {image.url && (
                  <MouseParallaxChild
                    factorX={0.01}
                    factorY={0.01}
                    inverted={true}
                    className={'parallax-bg'}
                  >
                    <BGImage src={image.url} alt={image.alt || image.title} />
                  </MouseParallaxChild>
                )}
                {decor_image.url && (
                  <MouseParallaxChild
                    factorX={0.03}
                    factorY={0.02}
                    inverted={true}
                    className={'parallax-decor'}
                  >
                    <Decor
                      src={decor_image.url}
                      alt={decor_image.alt || decor_image.title}
                      style={{
                        top: `${Math.round(
                          (decor_position.y / height) * 100
                        )}%`,
                        left: `${Math.round(
                          (decor_position.x / width) * 100
                        )}%`,
                      }}
                      isEditor={isEditor}
                    />
                  </MouseParallaxChild>
                )}
              </MouseParallaxContainer>
            )}
          </Image>
          {breadcrumbs && (
            <Container isWide={true}>
              <Breadcrumbs>
                {breadcrumbs.map((item, key) => (
                  <li key={key}>
                    <a href={item.url}>{item.label}</a>
                  </li>
                ))}
              </Breadcrumbs>
            </Container>
          )}
          <Content ref={ref}>
            <Container>{InnerBlocks}</Container>
          </Content>
        </InnerWrap>
      </CircleWrap>
    </Wrapper>
  )
}

SubPageHeader.propTypes = {
  breadcrumbs: PropTypes.array,
  children: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  align: PropTypes.string,
  isEditor: PropTypes.bool,
  image: PropTypes.object,
  decor_image: PropTypes.object,
  decor_position: PropTypes.object,
  setAttributes: PropTypes.func,
}

export default SubPageHeader
